<template>
    <div>
        <Head
            title="Панель магазина – размещайте предложения и зарабатывайте"
        />

        <div
            class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[25rem] mx-auto"
        >
            <h2 class="text-2xl text-center font-normal mb-6">
                Добро пожаловать!
            </h2>

            <DividerLine />

            <button
                v-if="this.telegramForm.initData"
                @click="authWithTelegram"
                class="mb-5 text-left appearance-none cursor-pointer rounded text-sm font-bold focus:outline-none focus:ring ring-primary-200 dark:ring-gray-600 relative disabled:cursor-not-allowed inline-flex items-center justify-center shadow h-9 px-3 0 text-white dark:text-gray-900 w-full flex justify-center bg-[#27a7e7]"
            >
                {{ telegramName }}
            </button>

            <form @submit.prevent="send">
                <div v-if="this.step === 'token'">
                    <div class="mb-6">
                        <label class="block mb-2" for="email">Почта:</label>
                        <input
                            v-model="form.email"
                            class="form-control form-input form-control-bordered w-full"
                            id="email"
                            type="email"
                            name="email"
                            :class="{
                                'form-control-bordered-error':
                                    form.errors.has('email'),
                            }"
                            autofocus=""
                            required
                            placeholder="Введите электронную почту"
                        />

                        <HelpText
                            class="mt-2 text-red-500"
                            v-if="form.errors.has('email')"
                        >
                            {{ form.errors.first("email") }}
                        </HelpText>
                    </div>

                    <Button
                        class="w-full flex justify-center"
                        type="submit"
                        :loading="form.processing"
                    >
                        <span>Получить код </span>
                    </Button>
                </div>

                <div v-if="this.step === 'code'">
                    <div class="mb-6">
                        <label class="block mb-2" for="code"
                            >Введите код из почты:</label
                        >
                        <input
                            v-model="form.code"
                            class="form-control form-input form-control-bordered w-full"
                            id="code"
                            name="code"
                            autofocus=""
                            required
                            type="number"
                            minlength="6"
                            :class="{
                                'form-control-bordered-error':
                                    form.errors.has('code'),
                            }"
                            placeholder="Код из письма"
                        />

                        <HelpText
                            class="mt-2 text-red-500"
                            v-if="form.errors.has('code')"
                        >
                            {{ form.errors.first("code") }}
                        </HelpText>
                    </div>

                    <div class="flex justify-between">
                        <OutlineButton
                            class="flex justify-center"
                            type="button"
                            @click="
                                () => {
                                    this.step = 'token';
                                    this.form.reset();
                                }
                            "
                            :loading="form.processing"
                        >
                            <span>Сменить почту</span>
                        </OutlineButton>

                        <Button
                            class="flex justify-center"
                            type="submit"
                            :loading="form.processing"
                        >
                            <span>Подтвердить</span>
                        </Button>
                    </div>
                </div>
            </form>

            <div class="mt-5">
                Этот кабинет предназначен для магазинов, здесь вы можете
                размещать предложения на Юмаркет.
            </div>
        </div>

        <Footer />
    </div>
</template>

<script>
import Auth from "@/layouts/Auth";
import Footer from "@/layouts/Footer";
import { Button, OutlineButton } from "laravel-nova-ui";

export default {
    name: "LoginPage",
    layout: Auth,
    components: { Button, OutlineButton, Footer },

    data: () => ({
        step: "token",
        form: Nova.form({ email: "", code: "" }),

        telegramForm: Nova.form({
            type: "telegram",
            initData: window?.Telegram?.WebApp?.initData,
        }),
        telegramName: null,
    }),

    mounted() {
        if (window?.Telegram?.WebApp?.initData) {
            const data = window.Telegram.WebApp.initDataUnsafe.user;
            const name = data?.first_name ?? data?.username;

            this.telegramName = name
                ? `Войти через Телеграм как «${name}»`
                : "Войти через Телеграм";
        }
    },

    methods: {
        async send() {
            try {
                this.form.withOptions({ resetOnSuccess: false });

                if (this.step === "token") {
                    const response = await this.form.post(Nova.url("/token"));

                    if (response.result) {
                        this.step = "code";
                        Nova.success("Код для авторизации отправлен на почту");
                    }
                } else {
                    const response = await this.form.post(Nova.url("/code"));

                    if (response?.token) {
                        window.location.href = Nova.config("base");
                    } else {
                        Nova.error("Неверный код");
                    }
                }
            } catch (error) {
                if (error.response?.status === 429) {
                    Nova.error(
                        "Слишком много попыток! Попробуйте через 3 минуты"
                    );
                } else {
                    Nova.error("Произошла ошибка! Попробуйте позже!");
                }
            }
        },

        async authWithTelegram() {
            try {
                const response = await this.telegramForm.post(
                    Nova.url("/token")
                );

                if (response?.token) {
                    window.location.href = Nova.config("base");
                } else {
                    Nova.error("Ошибка авторизации. Попробуйте ещё раз.");
                }
            } catch (error) {
                if (error.response?.status === 429) {
                    Nova.error(
                        "Слишком много попыток! Попробуйте через 3 минуты"
                    );
                } else {
                    Nova.error("Произошла ошибка! Попробуйте позже!");
                }
            }
        },
    },
};
</script>
